import { ArgumentNullException } from 'utility/exception/argument-null.exception';
import { PrimitiveValueObject } from 'utility/model/primitive-value-object.model';

export class BoardTitle extends PrimitiveValueObject<string> {
  static create(value: string): BoardTitle {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new BoardTitle(value);
  }
}
